import { styled } from 'stitches.config'

export const OurObsessionRoot = styled('section', {
  backgroundColor: '$accent-white',
  paddingTop: '$4',
  paddingBottom: '$4',
  '@bp2': {
    paddingTop: '$8',
    paddingBottom: '$8',
  },
})

export const OurObsessionHeader = styled('h2', {
  textAlign: 'center',
  color: '$primary-500',
  paddingBottom: '$4',
  '@bp2': {
    paddingBottom: '$8',
  },
})

export const OurObsessionContent = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: '$3',
  alignItems: 'center',
  backgroundColor: '$accent-white',
  padding: '$2 $2',
  borderRadius: '15px',
  '& *': {
    zIndex: '1',
  },
  '@bp2': {
    gap: '$9',
    borderRadius: '30px',
  },
  variants: {
    marginTop: {
      true: {
        marginTop: '$4',
        '@bp2': {
          marginTop: '$7',
        },
      },
      false: {
        marginTop: '0',
      },
    },
    orientation: {
      left: {
        '@bp2': {
          flexDirection: 'row',
        },
      },
      right: {
        '@bp2': {
          flexDirection: 'row-reverse',
        },
      },
    },
  },
})

export const HeartLightningContainer = styled('div', {
  display: 'none',
  '@bp3': {
    display: 'block',
    position: 'absolute',
    zIndex: '1',
    top: '0',
    right: '50%',
    transform: 'translateX(-50%)',
  },
})

export const OurObsessionImage = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  width: '100%',
  position: 'relative',
  '& img': {
    display: 'block !important',
    width: '100% !important',
    height: 'auto !important',
    objectFit: 'cover !important',
  },
  '@bp2': {
    flexDirection: 'row',
    width: '50%',
    '& img': {
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
    },
  },
})

export const OurObsessionText = styled('div', {
  position: 'relative',
  paddingLeft: '$2',
  paddingRight: '$2',
  width: '100%',
  '@bp2': {
    width: '50%',
  },
})

export const OurObsessionTitle = styled('h3', {
  color: '$primary-500',
  marginBottom: '$3',
  textAlign: 'center',
  '@bp2': {
    textAlign: 'left',
    marginBottom: '$4',
  },
})

export const OurObsessionBody = styled('p', {})

export const OurObsessionIcon = styled('div', {
  display: 'none',
  '@bp3': {
    display: 'block',
    position: 'absolute',
    right: '-$2',
    bottom: '-8rem',
    '& img': {
      borderRadius: '0px',
    },
  },
})
